
interface routeType{
    path: string;
    name: string;
    component?: any;
}

class VueRouter{
    cacheRoute:routeType[] =  [];
    pageVueApp: any;
    pageRouter:any = null;
    rootPath: string = '';
    tempEvent:any[] = [];
    registryVuePageAppMount=(event:(app:any)=>void)=>{
        this.tempEvent.push(event);
    }
    onVuePageAppMount=(app:any)=>{
        this.pageVueApp = app;
        let router = window.VueRouter.createRouter({
            history: window.VueRouter.createWebHistory(this.rootPath),
            mode:'history',
            routes: this.cacheRoute
        })
        this.pageRouter = router;
        this.pageVueApp.use(router);
        this.tempEvent.forEach(item=>{
            item(app);
        })
        this.tempEvent = [];
    }
    registryVueRoutes=(vueRoutes:routeType|routeType[])=>{
        if(!Array.isArray(vueRoutes)){
            vueRoutes = [vueRoutes];
        }
        this.cacheRoute = this.cacheRoute.concat(vueRoutes);
        if(this.pageRouter){//已经加载过路由了
            vueRoutes.forEach(route=>this.pageRouter.addRoute(this.rootPath,route))
        }
    }
}
export default new VueRouter();